export const types = {
	// Auth
	login: '[Auth] Login user',
	logout: '[Auth] Logout user',

	// User info
	setUser: '[User] Set info',
	cleanUser: '[User] Clean info',

	// Catalog info
	setCatalogs: '[Catalog] Set info',
	cleanCatalogs: '[Catalog] Clean info',

	// Clients info
	setClients: '[Role] Set Clients info',
	cleanClients: '[Role] Clean Clients info',

	// Providers info
	setProviders: '[Role] Set Providers info',
	cleanProviders: '[Role] Clean Providers info',

	// Bias info
	addBias: '[Bias] Add bias',
	setBiases: '[Bias] Set biases',
	setBias: '[Bias] Set info',
	cleanBias: '[Bias] Clean info',
	currentBias: '[Bias] Set current bias info',
	updateSubbiasesFlag: '[Bias] Refresh subbiases by checking flag',

	// Sidebar state
	setShowSideBar: '[Sidebar] Set state',
	resetSideBar: '[Sidebar] Reset state',

	// Individual areas
	setIndividualAreas: '[Indiv. Areas] Set state',
	cleanIndividualAreas: '[Indiv. Areas] Reset state',

	// Consult file system
	setFolders: '[File System] Get folders',
	currentPath: '[File System] Current path',
	resetPath: '[File System] Reset path',

	// Searcher
	setSearcher: '[Searcher] Set state',
	cleanSearcher: '[Searcher] Reset state',

	// UI
	setTheme: '[Theme] Set theme', // Symbol()
	setResetUI: '[Theme] Reset UI',
};
